<template>
  <div class="ra-product--card" @click="goToProduct">
    <div class="text">
      <h6>{{ title }}</h6>
      <p>{{ label }}</p>
    </div>
    <div class="icon">
      <i :class="`ra-icon--${icon}`" />
    </div>
  </div>
</template>

<script>
export default {
  name: "RaProductCard",
  props: {
    title: {
      type: String,
      required: true
    },
    label: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      default: ""
    },
    page: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    goToProduct() {
      this.$router.push({ name: this.page });
    }
  }
};
</script>

<style lang="scss" scoped>
.ra-product--card {
  background: #3c000c;
  box-shadow: 0 0 30px 0 rgb(82 63 105 / 7%);
  border-radius: 6px;
  padding: 20px 25px;
  position: relative;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
  transition: top 0.25s ease-in;

  &:hover {
    top: -3px;
    transition: top 0.25s ease-out;
  }

  .text {
    h6 {
      font-size: 1rem;
      font-weight: 500;
      color: #fff;
    }

    p {
      font-size: 0.75rem;
      margin-bottom: 5px;
      color: #fff;
      opacity: 0.7;
    }
  }

  .icon {
    i {
      font-size: 2rem;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>
